import Authenticated from 'components/auth/Authenticated';
import Teacher from 'components/layouts/teacher';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { JobPage } from 'features/JobPage';
import { fetchEducationalQualifications } from 'redux/educational_qualifications';
import { fetchOne } from 'redux/job_search/actions';
import FullPageLoading from 'components/loading/full_page';
import { useAhoy } from '../../hooks/useAhoy';

const PublicProfile = (props) => {
  const router = useRouter();
  const [loading, setLoading] = useState(true);

  const { id, newUser } = router.query;
  const isNewUser = () => newUser === 'true';
  const job = props.job || props.jobSearches?.job[id];

  const dispatch = useDispatch();

  const { trackEvent: trackAhoyEvent } = useAhoy();

  useEffect(() => {
    if (!job) {
      dispatch(fetchEducationalQualifications());
      props.dispatch(fetchOne(id));
    } else {
      setLoading(false);
    }
  }, [job, id]);

  useEffect(() => {
    if (job?.id) {
      trackAhoyEvent('Viewed Job Listing', { job_listing_id: job.id });
    }
  }, [props.jobSearches?.job[id]?.id]);

  return (
    <Authenticated redirectLoggedOut={false}>
      <Head>
        <title>{props.jobSearches?.job[id]?.title || 'Job Listing'} - EarlyDay.com</title>
      </Head>
      <Teacher hideNavButtons={isNewUser()}>
        <div className="w-screen -ml-[calc((100vw-100%)/2)]">
          {loading && <FullPageLoading />}
          {job && <JobPage job={job} />}
        </div>
      </Teacher>
    </Authenticated>
  );
};

function mapStateToProps(state) {
  return {
    jobSearches: state.jobSearches,
    currentUserProfile: state.currentUserProfile,
    loading: state.jobSearches.loadingOne,
  };
}

export default connect(mapStateToProps)(PublicProfile);
